require('./contractAresLoan.scss');

// @vendor
const React = require('react');
const { withRouter } = require("react-router-dom");
const PropTypes = require('prop-types');
// @common
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @components
const ContractAresLoanSidebar = require('./contractAresLoanSidebar/contractAresLoanSidebar');
const ContractAresLoanStep1 = require('./contractAresLoanStep1/contractAresLoanStep1');
const ContractAresLoanStep2 = require('./contractAresLoanStep2/contractAresLoanStep2');
const ContractAresLoanRequestError = require('./contractAresLoanRequestError/contractAresLoanRequestError');
const ContractAresLoanSuccess = require('./contractAresLoanSuccess/contractAresLoanSuccess');
// @core
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { formatText, FormattedText } = require('core/i18n').i18n;
// @constants
const constants = require('./contractAresLoan.constants');
const translations = require('./contractAresLoan.translations');
const dossierStatus = require('../../../loansConstants/dossierStatus');
// @utilities
const PersonalDataHelper = require('utilities/personalDataHelper');

class ContractAresLoan extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            agreeCheckbox: false,
        };

        this.handleAgreeCheckboxChange = this.handleAgreeCheckboxChange.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        scrollToTop();
    }

    handleAgreeCheckboxChange() {
        this.setState({ agreeCheckbox: !this.state.agreeCheckbox });
    }

    handleCancel() {
        this.props.history.push('/myprofile/global');
    }

    buildSidebar() {
        const { selectedAccount, immAresDossier, paymentDayType } = this.props;
        const contractingData = immAresDossier.get('dossier').get('contractingData');

        return (
            <div className="col-xs-4">
                <ContractAresLoanSidebar
                    selectedAccount={selectedAccount}
                    contractingData={contractingData}
                    paymentDayType={paymentDayType}
                />
            </div>
        );
    }

    builDisclaimerText() {
        return (
            <div className="contract-ares-loan__superscript-info">
                <FormattedText value={translations.WIZARD_OPENNING_FEE_LABEL} />
            </div>
        )
    }

    buildWizard() {
        const {
            immFlagBasedFeatures, immAresDossier, cancelDossier,
            paymentDayType, setPaymentDateType,
            selectedAccountId, selectedAccount, setSelectedAccount, immAccounts, getBlockedAccounts,
            immSteps, visibleStep, setVisibleStep, validateStep
        } = this.props;

        const actions = {
            finish: () => { return false },
            cancel: this.handleCancel,
            validateStep,
            setVisibleStep: step => setVisibleStep(step),
            setWillCancel: () => { return false },
            setWillGoBack: () => { return false; },
            resetStep: () => { return false; }
        };

        const preleaveModalMessage = formatText(translations.WIZARD_LEAVE_MODAL_DESCRIPTION);
        const preleaveModalTitle = formatText(translations.WIZARD_LEAVE_MODAL_TITLE);
        const preleaveModalLeftButtonConfig = {
            text: formatText(translations.WIZARD_LEAVE_MODAL_LEAVE_BUTTON),
            redirect: true,
            callback: cancelDossier,
        };
        const preleaveModalRightButtonConfig = {
            text: formatText(translations.WIZARD_LEAVE_MODAL_CONTINUE_LATER),
            redirect: true
        };

        const disclaimer = this.builDisclaimerText();

        return (
            <React.Fragment>
                <Wizard
                    {...constants.WIZARD}
                    immSteps={immSteps}
                    visibleStep={visibleStep}
                    actions={actions}
                    showPreLeaveModal
                    preleaveModalMessage={preleaveModalMessage}
                    preleaveModalTitle={preleaveModalTitle}
                    preleaveModalLeftButtonConfig={preleaveModalLeftButtonConfig}
                    preleaveModalRightButtonConfig={preleaveModalRightButtonConfig}
                >
                    <WizardStep
                        {...constants.WIZARD_STEP_1}
                        nextButtonCustomText={formatText(translations.WIZARD_NEXT_BUTTON)}
                        cancelButtonText={formatText(translations.WIZARD_ABANDON_BUTTON)}
                    >
                        <ContractAresLoanStep1
                            immFlagBasedFeatures={immFlagBasedFeatures}
                            immAresDossier={immAresDossier}
                            paymentDayType={paymentDayType}
                            setPaymentDateType={setPaymentDateType}
                            selectedAccount={selectedAccountId}
                            setSelectedAccount={setSelectedAccount}
                            immAccounts={immAccounts}
                            getBlockedAccounts={getBlockedAccounts}
                        />
                    </WizardStep>
                    <WizardStep
                        {...constants.WIZARD_STEP_2}
                        cancelButtonText={formatText(translations.WIZARD_ABANDON_BUTTON)}
                        finalButtonDisabled={!this.state.agreeCheckbox}
                        isLoading={immAresDossier.get('isFetching')}
                    >
                        <ContractAresLoanStep2
                            dossier={immAresDossier.get('dossier')}
                            paymentDayType={paymentDayType}
                            selectedAccount={selectedAccount}
                            agreeCheckbox={this.state.agreeCheckbox}
                            onAgreeCheckbox={this.handleAgreeCheckboxChange}
                        />
                    </WizardStep>
                </Wizard>
                {disclaimer}
            </React.Fragment>
        );
    }

    buildContent() {
        const sidebar = this.buildSidebar();
        const mainContent = this.buildWizard();

        return (
            <div className="row">
                <div className="col-xs-8">
                    {mainContent}
                </div>
                {sidebar}
            </div>
        );
    }

    render() {
        let content;
        const { immAresDossier, immProfile, paymentDayType } = this.props;
        const error = immAresDossier.get('error');
        const showLoading = immAresDossier.get('isFetching');
        const success = immAresDossier.get('dossier') && immAresDossier.get('dossier').get('status') === dossierStatus.LOAN_COMPLETE;

        if (showLoading) {
            content = <LoadingSection />;
        } else if (success) {
            const contractingData = immAresDossier.get("dossier").get("contractingData");
            const email = PersonalDataHelper.getEmail(immProfile);
            content = <ContractAresLoanSuccess contractingData={contractingData} paymentDayType={paymentDayType} email={email} />;
        } else if (error) {
            content = <ContractAresLoanRequestError error={error}/>;
        } else if (immAresDossier.get('dossier')) {
            content = this.buildContent();
        }

        return (
            <div className="row">
                {content}
            </div>
        );
    }
}

ContractAresLoan.propTypes = {
    immFlagBasedFeatures: PropTypes.object.isRequired,
    // Dossier Reducer
    immAresDossier: PropTypes.object.isRequired,
    cancelDossier: PropTypes.func.isRequired,
    // payment day type
    paymentDayType: PropTypes.string.isRequired,
    setPaymentDateType: PropTypes.func.isRequired,
    // accounts
    selectedAccountId: PropTypes.string,
    selectedAccount: PropTypes.object,
    setSelectedAccount: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    // steps
    immSteps: PropTypes.object.isRequited,
    visibleStep: PropTypes.number.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    // profile
    immProfile: PropTypes.object,
    history: PropTypes.object.isRequired,
};

module.exports = withRouter(ContractAresLoan);
